import { NotificacaoEnum } from './notificacao.enum';
export class Notificacao {

        _mensagem: string;
        _tipo: NotificacaoEnum;
        _titulo: string;
        _timeout: number;
/**
 * @return {?}
 */
get mensagem() {
            return this._mensagem;
        }
/**
 * @param {?} mensagem
 * @return {?}
 */
set mensagem(mensagem: string) {
            this._mensagem = mensagem;
        }
/**
 * @return {?}
 */
get tipo() {
            return this._tipo;
        }
/**
 * @param {?} tipo
 * @return {?}
 */
set tipo(tipo: NotificacaoEnum) {
            this._tipo = tipo;
        }
/**
 * @return {?}
 */
get titulo() {
          return this._titulo;
        }
/**
 * @param {?} titulo
 * @return {?}
 */
set titulo(titulo: string) {
          this._titulo = titulo;
        }
/**
 * @return {?}
 */
get timeout() {
          return this._timeout;
        }
/**
 * @param {?} timeout
 * @return {?}
 */
set timeout(timeout: number) {
          this._timeout = timeout;
        }
}

function Notificacao_tsickle_Closure_declarations() {
/** @type {?} */
Notificacao.prototype._mensagem;
/** @type {?} */
Notificacao.prototype._tipo;
/** @type {?} */
Notificacao.prototype._titulo;
/** @type {?} */
Notificacao.prototype._timeout;
}

